import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

export const supportedLngs = {
  en: 'English',
  test: 'Test Language'
};

export function initialise(basePath: string) {
  return i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng: 'en',
      ns: ['common', 'commonBackendKeys'],
      defaultNS: 'common',
      backend: {
        loadPath: `${basePath}/locales/axa/{{lng}}/{{ns}}.json`
      },
      fallbackLng: 'en',
      nsSeparator: false,
      keySeparator: false,
      interpolation: { escapeValue: false }
    });
}

export default i18n;
